import React, { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Brand } from "../components/Layout";
import { useI18n } from "../lib/i18n";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function Login() {
  const { t } = useI18n();
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const u = await login(email, password);
      const dest = u.role === "admin" ? "/admin" : u.role === "partner" ? "/partner" : (location.state?.from || "/account");
      navigate(dest);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between bg-[#0F172A] text-white p-12 hero-grid-bg">
        <Brand light />
        <div>
          <h2 className="font-heading text-3xl font-bold leading-tight">{t("hero.title")}</h2>
          <p className="mt-4 text-slate-300">{t("value.prop")}</p>
        </div>
        <span className="text-xs text-slate-500">© {new Date().getFullYear()} RamenHersteller.be</span>
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <div className="lg:hidden mb-8"><Brand /></div>
          <h1 className="font-heading text-2xl font-bold text-slate-900">{t("auth.login")}</h1>
          {error && <p className="mt-4 rounded-lg bg-red-50 border border-red-200 p-3 text-sm text-red-700" data-testid="login-error">{error}</p>}
          <div className="mt-6 space-y-4">
            <div><Label>{t("auth.email")}</Label><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" className="mt-1" /></div>
            <div><Label>{t("auth.password")}</Label><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" className="mt-1" /></div>
          </div>
          <Button type="submit" className="cta-orange w-full rounded-full mt-6 py-6" disabled={loading} data-testid="login-submit">
            {loading ? <Loader2 className="animate-spin" /> : t("auth.loginbtn")}
          </Button>
          <p className="mt-4 text-sm text-slate-500 text-center">
            {t("auth.noaccount")} <Link to="/register" className="text-brand-orange font-semibold" data-testid="goto-register">{t("auth.register")}</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
